module.exports = __webpack_public_path__ + "img/radio-traxx.0a686746.jpg";